import CourseIcon from 'modules/Nav/icons/CourseIcon'
import DashboardIcon from 'modules/Nav/icons/DashboardIcon'
import DriveIcon from 'modules/Nav/icons/DriveIcon'
import EventIcon from 'modules/Nav/icons/EventIcon'
import PlacementIcon from 'modules/Nav/icons/PlacementIcon'
import RolesIcon from 'modules/Nav/icons/RolesIcon'
import RuleEngineIcon from 'modules/Nav/icons/RuleEngineIcon'
import SettingsIcon from 'modules/Nav/icons/SettingsIcon'
import Speed from 'modules/Nav/icons/SpeedIcon'
import StudentsIcon from 'modules/Nav/icons/StudentsIcon'
import UsersIcon from 'modules/Nav/icons/UsersIcon'
import CorporateIcon from './icons/CorporateIcon'
import TPORequestsIcon from './icons/TPORequestsIcon'
import ReportsIcon from './icons/ReportsIcon'
import BagIcon from './icons/BagIcon'
import ApprovalIcon from './icons/ApprovalIcon' 
export const navItems = [
  {
    // Stays on the legacy v1 dashboard. The v2 cockpit is reached through the
    // Assessment entry below instead — v2 is the assessment product, and the
    // Dashboard entry keeps serving the wider institute view.
    path: '/tpoDashboard',
    icon: DashboardIcon,
    navTitle: 'Dashboard',
    pageTitle: 'Dashboard',
    menuType: 'GlobalMenu',
  },
  {
    path: '/students',
    icon: StudentsIcon,
    navTitle: 'Students',
    pageTitle: 'Students',
    menuType: 'GlobalMenu',
  },
  {
    path: '/corporate',
    icon: CorporateIcon,
    navTitle: 'Global',
    pageTitle: 'Corporate',
    menuType: 'GlobalMenu',
  },
  {
    path: '/roles',
    icon: RolesIcon,
    navTitle: 'Roles',
    pageTitle: 'PIL Roles',
    menuType: 'GlobalMenu',
  },
  {
    path: '/placement',
    icon: PlacementIcon,
    navTitle: 'Global',
    pageTitle: 'Batch Folders',
    menuType: 'GlobalMenu',
  },
  {
    path: '/jobRoles',
    icon: RolesIcon,
    navTitle: 'Global',
    pageTitle: 'Job Roles',
    menuType: 'GlobalMenu',
  },
  // {
  //   path: '/tpoDashboard',
  //   icon: RolesIcon,
  //   navTitle: 'Global',
  //   pageTitle: 'TPO Dashboard',
  //   menuType: 'GlobalMenu',
  // },
  {
    path: '/events',
    icon: EventIcon,
    navTitle: 'Global',
    pageTitle: 'Events',
    menuType: 'GlobalMenu',
  },
  // {
  //   path: '/drives',
  //   icon: DriveIcon,
  //   navTitle: 'Drives',
  //   pageTitle: 'PIL Drives',
  //   menuType: 'GlobalMenu',
  // },
  {
    path: '/users',
    icon: UsersIcon,
    navTitle: 'Users',
    pageTitle: 'Users',
    menuType: 'GlobalMenu',
  },

  {
    path: '/ruleEngine',
    icon: RuleEngineIcon,
    navTitle: 'Rule Engine',
    pageTitle: 'Rule Engine',
    menuType: 'GlobalMenu',
  },
  // {
  //   path: '/tpoRequests',
  //   icon: TPORequestsIcon,
  //   navTitle: 'Global',
  //   pageTitle: 'TPO Requests',
  //   menuType: 'GlobalMenu',
  // },
  {
    path: '/approvals',
    icon: ApprovalIcon,
    navTitle: 'Global',
    pageTitle: 'Approvals',
    menuType: 'GlobalMenu',
  },
  // {
  //   path: '/tpoApproval',
  //   icon: ApprovalIcon,
  //   navTitle: 'Global',
  //   pageTitle: 'TPOApproval',
  //   menuType: 'GlobalMenu',
  // },
  {
    path: '/reports',
    icon: ReportsIcon,
    navTitle: 'Reports',
    pageTitle: 'Reports',
    menuType: 'GlobalMenu',
  },
  {
    path: '/setting',
    icon: SettingsIcon,
    navTitle: 'Settings',
    pageTitle: 'Settings',
    menuType: 'GlobalMenu',
  },
  {
    path: '/courses',
    icon: CourseIcon,
    navTitle: 'Courses',
    pageTitle: 'Courses',
    menuType: 'GlobalMenu',
  },


  {
    // Strangler-fig: Assessments has been rewritten as the v2 Next app
    // (institute-react-v2, served at the same origin under basePath /v2).
    // The entry lands on the v2 dashboard — that cockpit is the assessment
    // landing page, and its own nav leads on to /v2/assessments. v1's
    // /assessment route registration is kept for safety (opened-in-old-tab,
    // in-flight links) but the nav never lands there.
    path: '/v2/dashboard',
    icon: BagIcon,
    navTitle: 'Global',
    pageTitle: 'Assessment',
    menuType: 'GlobalMenu',
  },




  // {
  //   path: '/reports',
  //   icon: Speed,
  //   navTitle: 'Reports',
  //   pageTitle: 'Reports',
  //   menuType: 'GlobalMenu',
  //   externalMenu: [
  //     {
  //       path: '/reports/candidate/master',
  //       icon: RolesIcon,
  //       navTitle: 'Candidate Master',
  //       pageTitle: 'Candidate Master',
  //       menuType: 'externalMenu',
  //     },
  //     {
  //       path: '/reports/active/corporates',
  //       icon: RolesIcon,
  //       navTitle: 'Corporates Actively Engaged',
  //       pageTitle: 'Active Corporates',
  //       menuType: 'externalMenu',
  //     },
  //     {
  //       path: '/reports/active/role',
  //       icon: RolesIcon,
  //       navTitle: 'Active Roles',
  //       pageTitle: 'Active Roles',
  //       menuType: 'externalMenu',
  //     },
  //     {
  //       path: '/reports/candidate/application/status',
  //       icon: Speed,
  //       navTitle: 'Candidate Application Status',
  //       pageTitle: 'Candidate Application Status',
  //       menuType: 'externalMenu',
  //     },
  //   ],
  // },
  {
    path: '/activity-log',
    icon: SettingsIcon,
    navTitle: 'Activity Log',
    pageTitle: 'Activity Log',
    menuType: 'GlobalMenu',
  },
]
